import { Error } from "@mui/icons-material";
import { Box, Button, Container, Typography } from "@mui/material";
import { BiError } from "react-icons/bi";
import { CRIMSON_RED } from "../../../../enums/Colors";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound({ title = "", subtitle = "" }) {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography variant="h4" color="text.secondary" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Container>
  );
}

export function ErrorMessage({
  title = "",
  subtitle = "",
  showBackButton = true,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  function handleNavigate() {
    navigate(-1);
  }
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ textAlign: "center", py: 8 }}>
        <BiError scale={"5.0"} size={"9rem"} color={CRIMSON_RED} />
        <Typography variant="h4" color="text.secondary" gutterBottom>
          {t(title)}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {t(subtitle)}
        </Typography>
        {showBackButton && (
          <Button
            sx={{ mt: 2 }}
            variant="outlined"
            onClick={() => handleNavigate()}
          >
            {t("GoBack")}
          </Button>
        )}
      </Box>
    </Container>
  );
}
